module.exports = __webpack_public_path__ + "img/pencil.19cac64f.svg";